<template>
	<v-fade-transition group name="fade">
		<v-container 
			v-for="dialog in dialogs"
			:key="dialog.key"
			fluid
			fill-height
			class="alertContainer"
		>
			<v-layout justify-center align-center>
				<v-flex md4>
					<v-card>
						<v-card-title class="headline primary">
							<span class="white--text">{{ dialog.text }}</span>
						</v-card-title>
						<v-card-text>
							<span v-html="dialog.message" />
						</v-card-text>

						<div v-if="dialog.actions">
							<v-divider />

							<v-card-actions>
								<v-container grid-list-lg>
									<v-layout row wrap>
										<v-flex v-for="(action, index) in dialog.actions" :key="index" md12>
											<v-btn block :color="action.type" @click="onClickAction (action, dialog.key)">
												<span class="white--text font-weight-medium">{{ action.text }}</span>
											</v-btn>
										</v-flex>
									</v-layout>
								</v-container>
							</v-card-actions>
						</div>
						<div v-if="dialog.dismissable">
							<v-divider class="divider" />
							<v-layout justify-end>
								<v-btn flat color="error" @click="dismiss (dialog.key)">
									<span class="font-weight-medium">Chiudi</span>
								</v-btn>
							</v-layout>
						</div>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
	</v-fade-transition>
</template>

<script>
import { mapState, mapMutations } from 'vuex' 

export default {
	computed: mapState ({
		dialogs: state => state.dialog.dialogs
	}),
	methods: {
		dismiss (key) {
			this.removeDialog (key)
		},
		...mapMutations ([
			'setDialog',
			'removeDialog'
		]),
		onClickAction (action, key) {
			if (action.handler)
				action.handler ()
			this.dismiss (key)
		}
	}
}
</script>

<style>
.alertContainer {
	background-color:rgba(0, 0, 0, 0.4);
	position: absolute;
	z-index: 1000;
	top: 0px;
}
</style>

